import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";

const idSchema = z.object({ id: z.string().uuid() });

export const incrementGalleryLike = createServerFn({ method: "POST" })
  .inputValidator((input: { id: string }) => idSchema.parse(input))
  .handler(async ({ data }) => {
    const { supabaseAdmin } = await import("@/integrations/supabase/client.server");
    const { data: count, error } = await supabaseAdmin.rpc("increment_gallery_like", { _id: data.id });
    if (error) { console.error("incrementGalleryLike:", error); throw new Error("Failed"); }
    return typeof count === "number" ? count : 0;
  });

export const incrementGalleryShare = createServerFn({ method: "POST" })
  .inputValidator((input: { id: string }) => idSchema.parse(input))
  .handler(async ({ data }) => {
    const { supabaseAdmin } = await import("@/integrations/supabase/client.server");
    const { data: count, error } = await supabaseAdmin.rpc("increment_gallery_share", { _id: data.id });
    if (error) { console.error("incrementGalleryShare:", error); throw new Error("Failed"); }
    return typeof count === "number" ? count : 0;
  });
